export const URINALYSIS_GLUCOSE_OPTIONS = [
  { label: "Negative", value: "NEGATIVE" },
  { label: "Trace (100mg/dl)", value: "TRACE" },
  { label: "1+ (250mg/dl)", value: "ONE_PLUS" },
  { label: "2+ (500mg/dl)", value: "TWO_PLUS" },
  { label: "3+ (1000mg/dl)", value: "THREE_PLUS" },
  { label: "4+ (2000+mg/dl)", value: "FOUR_PLUS" },
];

export const URINALYSIS_PROTEIN_OPTIONS = [
  { label: "Negative", value: "NEGATIVE" },
  { label: "Trace", value: "TRACE" },
  { label: "1+ (30mg/dl)", value: "ONE_PLUS" },
  { label: "2+ (100mg/dl)", value: "TWO_PLUS" },
  { label: "3+ (300mg/dl)", value: "THREE_PLUS" },
  { label: "4+ (>2000mg/dl)", value: "FOUR_PLUS" },
];

/*
 * Ketones, blood and leucocytes were yes/no tick boxes until Darren said a dipstick grade cannot
 * be flattened to a tick — "having a tick box for some they will pull us up" — and Eleanor settled
 * the shape: "Only nitrates should be a checkbox." These lists are hers, confirmed by Darren.
 *
 * Ketones grade in pluses like glucose and protein; blood and leucocytes in words. That is how the
 * dipstick reads them, so the two scales differ on purpose.
 *
 * That nitrites exemption no longer holds — see URINALYSIS_NITRITES_OPTIONS below.
 */
export const URINALYSIS_KETONES_OPTIONS = [
  { label: "Negative", value: "NEGATIVE" },
  { label: "Trace", value: "TRACE" },
  { label: "1+", value: "ONE_PLUS" },
  { label: "2+", value: "TWO_PLUS" },
  { label: "3+", value: "THREE_PLUS" },
];

export const URINALYSIS_BLOOD_LEUCOCYTES_OPTIONS = [
  { label: "Negative", value: "NEGATIVE" },
  { label: "Trace", value: "TRACE" },
  { label: "Small", value: "SMALL" },
  { label: "Moderate", value: "MODERATE" },
  { label: "Large", value: "LARGE" },
];

/*
 * Nitrites was the one field kept as a tick box, because unlike the others the strip really does
 * report it as present or absent — there is no grade to throw away. Darren then asked for it to
 * be a dropdown too: "its odd to have 1 random tick box and makes it be missed by a user". Both
 * readings were fair — the first is about the measurement, the second about the form — and the
 * team settled on the dropdown, so the field reads like its four neighbours and is not skipped.
 *
 * Only the two values the strip can report. The dipstick has no "trace" for nitrites, so this
 * list is deliberately shorter than the graded ones rather than being padded to match them.
 *
 * Note this is nearer the stored data than the tick box was: the column has always been a string
 * holding "POSITIVE", which the form used to convert to a boolean and back. Nothing migrates —
 * a positive result keeps the value it already had.
 */
export const URINALYSIS_NITRITES_OPTIONS = [
  { label: "Negative", value: "NEGATIVE" },
  { label: "Positive", value: "POSITIVE" },
];

/*
 * What a tick used to be saved as. A result recorded before the grades existed says only that
 * something was present, so it keeps saying exactly that rather than being assigned a grade
 * nobody measured. Offered only when the record already holds it — it must not be selectable on a
 * one, which is why it is not in the lists above.
 */
export const URINALYSIS_LEGACY_POSITIVE = {
  label: "Positive (no grade recorded)",
  value: "POSITIVE",
};

/**
 * The options to show for a field, including the legacy value when that is what is stored.
 *
 * Disabled, so the record reads truthfully and can be re-graded, but nobody can choose "no grade
 * recorded" on purpose.
 */
export const withLegacyPositive = (options, value) =>
  value === URINALYSIS_LEGACY_POSITIVE.value
    ? [...options, { ...URINALYSIS_LEGACY_POSITIVE, disabled: true }]
    : options;

/** The label a stored code reads as, for the free-text summary. */
export const urinalysisLabelFor = (options, value) =>
  value === URINALYSIS_LEGACY_POSITIVE.value
    ? URINALYSIS_LEGACY_POSITIVE.label
    : (options.find((option) => option.value === value)?.label ?? value);
